var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbar"},_vm._l((_vm.tabList),function(item){return _c('div',{class:_vm.activeIndex == item.id ? 'active' : '',on:{"click":function($event){return _vm.changeTab(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }